export default __webpack_public_path__ + "static/media/880.863be0dc.gif";